import { i18n } from '../../../plugins/i18n'

interface ServiceType {
  id: 'google_map' | 'yahoo_map';
  name: string;
}

export const mediaLibraryServicesConst: ServiceType[] = [
  {
    id: 'google_map',
    name: i18n.t('labels.sites.google')
  },
  {
    id: 'yahoo_map',
    name: i18n.t('labels.sites.yahooMap')
  },
]
